import React, { PureComponent, PropTypes } from 'react';

import Heading from '../Common/Heading';
import CheckBox from '../Common/CheckBox';

export default class AdditionalOptions extends PureComponent {
    static propTypes = {
        person: PropTypes.object.isRequired,
        privateUse: PropTypes.bool.isRequired,
        setNewBookingPrivateUse: PropTypes.func.isRequired,
    }

    render() {
        const privateUseJsx = this.props.person.requirements.privateUse
            ? <CheckBox label="Private Use" isChecked={this.props.privateUse} onChange={this.props.setNewBookingPrivateUse} />
            : null;

        return (
            <div className="fixed-header-view">
                <Heading title="Additional Options" />
                {privateUseJsx}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./scripts/components/Create/AdditionalOptions.jsx